import _ from 'underscore';
const {Backbone} = require('backboneAdapter');
import AppUserActionModel from 'js/models/profile.appuseraction.model';

    export default Backbone.Collection.extend({
        model: AppUserActionModel,
        url: "/CampaignCloud/AppUserActionController/actions"
    });
